import React from 'react';
import { useConnect } from '@lore/query-connect';
import { PayloadStates } from '@lore/utils';
import Loader from '../../components/Loader';
import useDialogConfig from '../../../hooks/@lore/dialogs-routable/_hooks/useDialogConfig';
import Dialog from '../claim_decline';
import { useQueryClient } from '@tanstack/react-query';

export default function Launcher(props) {
  const config = useDialogConfig();
  const queryClient = useQueryClient();

  const claim = useConnect('claim.byId', {
    id: config.params.claimId
  });

  const offer = useConnect('offer.byId', {
    id: claim.data.offerId
  }, {
    enabled: !!claim.data.offerId
  });

  if (
    claim.state === PayloadStates.FETCHING ||
    offer.state === PayloadStates.FETCHING
  ) {
    return (
      <Loader />
    );
  }

  return (
    <Dialog
      claim={claim}
      offer={offer}
      onClose={props.onClose}
      onSubmit={function(request) {
        queryClient.invalidateQueries({ queryKey: ['claim'] });
      }}
    />
  );
};
